module.exports = __webpack_public_path__ + "static/jacksonhh-7e4856e071b10c781bb1616fbaff8d11.jpg";